import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { legacySiteId, type LegacySiteId } from './LegacySite.js'
import { projectId, type ProjectId } from './Project.js'

/** Represents the view public.project_site_geo_view_ */
export default interface ProjectSiteGeoViewTable {
  /** Database type: pg_catalog.int4 */
  projectId: ColumnType<ProjectId, never, never>

  /** Database type: pg_catalog.int4 */
  siteId: ColumnType<LegacySiteId, never, never>

  /** Database type: pg_catalog.text */
  siteName: ColumnType<string, never, never>

  /** Database type: pg_catalog.text */
  status: ColumnType<string, never, never>

  /** Database type: pg_catalog.bool */
  visible: ColumnType<boolean | null, never, never>

  /** Database type: pg_catalog.numeric */
  geoLat: ColumnType<number, never, never>

  /** Database type: pg_catalog.numeric */
  geoLon: ColumnType<number, never, never>
}

export type ProjectSiteGeoView = Selectable<ProjectSiteGeoViewTable>

export const projectSiteGeoView = z.object({
  projectId: projectId,
  siteId: legacySiteId,
  siteName: z.string(),
  status: z.string(),
  visible: z.boolean().nullable().optional(),
  geoLat: z.number(),
  geoLon: z.number(),
}) as unknown as z.Schema<ProjectSiteGeoView>
